<template>
  <div class="gc-start-screen gc-text-center gc-p-8 gc-rounded">
    <gc-image
      :src="`${baseUrl}/header-background.jpg`"
      class="gc-start-screen__background-image gc-rounded"
      v-if="showHeaderBackground"
    />

    <div class="gc-start-screen__overlay gc-rounded"></div>

    <div class="gc-start-screen__content">
      <div class="gc-flex gc-flex-col gc-items-center">
        <i
          class="gc-start-screen__icon gc-bg-primary gc-mb-3 gc-text-base gc-w-16 gc-h-16 gc-flex gc-items-center gc-justify-center"
        >
          <font-awesome-icon :icon="headerIcon" size="2x" />
        </i>
        <div>
          <h2 class="gc-mb-0 gc-font-bold gc-text-lg">
            {{ $t('start.title') }}
          </h2>
          <transition name="fade" mode="out-in" v-if="!started">
            <div
              v-if="$te('start.description.html')"
              v-html="$t('start.description.html')"
            />
            <p class="gc-mb-0 gc-mt-1" v-else>
              {{ $t('start.description') }}
            </p>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';
import GcImage from '@/components/primitives/GcImage.vue';
import { headerIcon } from '~/plugins/font-awesome';

export default defineComponent({
  components: {
    GcImage,
  },
  props: {
    started: {
      default: false,
      type: Boolean,
    },
  },
  setup: () => {
    const showHeaderBackground: boolean =
      process.env.VUE_APP_SHOW_HEADER_BACKGROUND !== 'false';
    const baseUrl = process.env.VUE_APP_BASE_URL;
    return {
      baseUrl,
      headerIcon,
      showHeaderBackground,
    };
  },
});
</script>

<style lang="scss" scoped>
.gc-start-screen {
  position: relative;
  z-index: 900;
}

.gc-start-screen__background-image,
.gc-start-screen__overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1;
}

.gc-start-screen__overlay {
  z-index: 2;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.75);
}

.gc-start-screen__content {
  position: relative;
  z-index: 2000;
}
.gc-start-screen__icon {
  border-radius: 50%;
  flex-shrink: 0;
  color: white;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 300ms ease-in-out;
}
</style>
